// extracted by mini-css-extract-plugin
export default {"deleteOverlay":"u3-z","cancel":"v3-z","disabled":"w3-z","delete":"x3-z"};